export default {
  navigation: {
    next: 'Next',
    back: 'Back',
    surveyNavigation: 'Survey navigation',
    workspace: {
      home: 'Home',
      example: 'Example',
    },
  },
}
